<template>
  <div v-if="overall" class="teacher-item-lessons">
    <BaseIcon name="people" :color="color" size="xs" mode="outlined" />
    <span class="teacher-item-lessons__overall">{{ overall }}</span>
    <span class="teacher-item-lessons__label">{{ $t('common.labels.lessons') }}</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TeacherListItemsLessons',
  inject: ['teacher'],
  computed: {
    ...mapGetters('local', ['getTutorListDesignColor']),
    color () {
      return this.teacher?.designColor || this.getTutorListDesignColor
    },
    overall () {
      return this.teacher.statistics?.students?.lessons
    }
  }
}
</script>

<style scoped lang="scss">
.teacher-item-lessons {
  @apply flex items-center space-x-2 text-body-1;
  &__overall {
    @apply  text__caption-xs--bold lg:text__body-2-xs--semibold text-body-1;
  }
  &__label {
    @apply text__caption-xs--regular lg:text__body-2-xs--regular text-body-2;
  }
}
</style>
